import React, { useEffect, useState } from 'react';
import { browserHistory } from 'react-router';
import LiveCasino from '@it25syv/live-casino';
import UserService from '../utils/UserService';
import { NotificationManager } from 'react-notifications';
import { checkUserExclusionStatus } from 'utils/Helper';

const LiveCasinoPage = ({ params, showModal = {} }) => {
    const history = browserHistory;
    const [userInfo, setUserInfo] = useState(null);

    useEffect(() => {
        UserService.InfoGet().then((res) => {
            if (res.success && res?.data) {
                setUserInfo(res.data);
            }
        });
    }, []);

    const showSelfExcludedModal = () => {
        checkUserExclusionStatus();
    };

    return (
        <LiveCasino
            appName={'bet25'}
            matchUrl={(category) => {
                history.push('/sport/live-casino/' + category);
            }}
            urlParams={params}
            menuColors={{
                btnColor: '#EBEBEB',
                btnActiveColor: '#EDF1F8',
                btnActiveTextColor: '#1C3E60',
                btnHoverColor: '#000000',
            }}
            showThumbsByProviders={['evolution']}
            showGamesByProviders={['evolution']}
            userInfo={userInfo}
            notificationHandler={(notification) => {
                switch (notification.type) {
                    case 'warning':
                        NotificationManager.warning(notification.text);
                        break;
                    case 'error':
                        NotificationManager.error(notification.text);
                        break;
                    case 'selfExcluded':
                        showSelfExcludedModal();
                        break;
                    default:
                        NotificationManager.warning(notification.text);
                        break;
                }
            }}
        />
    );
};

export default LiveCasinoPage;
